// extracted by mini-css-extract-plugin
export default {"nameLink":"QueriesPage_nameLink__9s3S4","rowActions":"QueriesPage_rowActions__8bUBl","removeButton":"QueriesPage_removeButton__E8xbk"};